var DualRowPackageWithDifferentPadsData = require('./dualRowPackageWithDifferentPadsData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var RectangleData = require('../../../svg/rectangleData.js');
var IPCRules = require('../ipcRules');

var ToDpakData = function(position, angle, init) {
    DualRowPackageWithDifferentPadsData.apply(this, arguments);
 
    var self = this;

	//pad width for odd size pad which is different from others
    this.oddPadWidthMax = this.value("oddPadWidthMax", true);
    this.oddPadWidthMin = this.value("oddPadWidthMin", true);

    //extended length of odd pad outside body
    //it is used to shift assembly outline
    this.extendedEdgeWidth = this.value("extendedEdgeWidth", true);

    //middle I/O pins is truncated in 3d model for packages with specific pin counts (4, 6, 8)
    this.hasTruncatedPin = this.value("hasTruncatedPin", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.extendedEdgeWidth);

    this.horizontalPadCount.onChange("updateTruncatedPin", function (value) {
        if(value !== 4 && value !== 6 && value !== 8) {
            self.hasTruncatedPin(false);
        }
    });
};

lib_core.inherit(ToDpakData, DualRowPackageWithDifferentPadsData);
lib_core.JsonParser.registerClass(ToDpakData, "ToDpakData");

module.exports = ToDpakData;

ToDpakData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageWithDifferentPadsData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["oddPadWidth"] = [this.oddPadWidthMin, this.oddPadWidthMax];
    this.validationMap["oddPadWidthMax"] = [this.oddPadWidthMax];
    this.validationMap["extendedEdgeWidth"] = [this.extendedEdgeWidth];  
};

ToDpakData.prototype.getAssemblyOutline = function(pads) {
    if (pads.length === 0) return;

    var body = this.getBodyForAssembly();
    var assemblyOutline = new RectangleData(new lib_geometry.Coord(0, 0), 0, body.width, body.height, false, IPCRules.assemblyOutlineStrokeWidth);

    //(TODO: Verify) Shift assembly outline. Shift amount is calculated using extended edge minimum.
    assemblyOutline.move(new lib_geometry.Coord((this.horizontalLeadToLeadSpanMax() / 2 + this.horizontalLeadToLeadSpanMin() / 2) / 2 - body.width / 2 - (this.extendedEdgeWidth() - IPCRules.extendedEdgeTol), 0));

    return assemblyOutline;
};

/**
 * Get silkscreen pin one marker
 * @param {PadData} firstPad first pad data
 * @param {object} body body for silkscreen
 */
ToDpakData.prototype.getPinOneMarker = function(firstPad, body) {
    var pinMarkerSize = IPCRules.dotPinMarkerSize,
        pinMarkerPosX,
        pinMarkerPosY;

    //place the marker at the center of first pad
    pinMarkerPosX = firstPad.getPos().x; //what happens if pad gets inside body (never be the case for this package though)
    pinMarkerPosY = firstPad.getPos().y + firstPad.getTopCopper().height() / 2 + IPCRules.silkscreenPinMarkerDotClearance + pinMarkerSize / 2;

    return new EllipseData(new lib_geometry.Coord(pinMarkerPosX, pinMarkerPosY), 0, pinMarkerSize, pinMarkerSize, true, 0);
};

ToDpakData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimensions depending on mapping type of silkscreen to body
    var body = this.getBodyForSilkscreen();

    //left side pads
    var firstPad = pads[0];

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(firstPad, body));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    
    //apply transformation on body
    var bodyOutline = new RectangleData(new lib_geometry.Coord(0, 0), 0, body.width, body.height, false);
    bodyOutline.move(new lib_geometry.Coord((this.horizontalLeadToLeadSpanMax() / 2 + this.horizontalLeadToLeadSpanMin() / 2) / 2 - body.width / 2 - (this.extendedEdgeWidth() - IPCRules.extendedEdgeTol), 0));

    var oddPad = pads[pads.length - 1];

    var pathData = new PathData(new lib_geometry.Coord(bodyOutline.pos().x + body.width / 2, oddPad.getPos().y + oddPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(bodyOutline.pos().x + body.width / 2, body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(bodyOutline.pos().x - body.width / 2, body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(bodyOutline.pos().x - body.width / 2, -body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(bodyOutline.pos().x + body.width / 2, -body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(bodyOutline.pos().x + body.width / 2, oddPad.getPos().y - oddPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance), PathType.LINE));
    silkscreen.push(pathData);

    return silkscreen;
};
